<dsd-container class="info-courriels-credit" background-color="dsd-color-background-page" borderRadius="sm">
  <ng-container *ngFor="let particulierCredit of reponseCoordonneesCredit?.particulierCredit; let i = index">
    <p [ngClass]="{ 'dsd-mb-0': i === reponseCoordonneesCredit?.particulierCredit?.length - 1 }">
      <span class="libelle-credit"> {{ particulierCredit?.carte?.descriptionCourte }}&nbsp; </span>
      <span class="libelle-credit" aria-hidden="true">
        ({{ particulierCredit?.carte?.numeroCarte?.substring(12, 16) }})
      </span>
      <span class="dsd-sr-only"
        >{{ 'caad.accueil.libelle.horsEcran.carteCreditTerminant' | translate }} ({{
          particulierCredit?.carte?.numeroCarte?.substring(12, 16)
        }})</span
      >
      <span class="valeur">{{ particulierCredit?.adresseCourriel?.adresseCourriel }}</span>
    </p>
  </ng-container>
</dsd-container>

<!-- Alerte -->
<dsd-alert variant="warning">
  <h2 slot="title">{{ 'caad.modifier-fiserv.courriel.avertissement.titre' | translate }}</h2>
  <p>{{ 'caad.modifier-fiserv.courriel.avertissement.message' | translate }}</p>
</dsd-alert>
